import { render } from "./RegistrationFlow.vue?vue&type=template&id=3cda229b&scoped=true"
import script from "./RegistrationFlow.vue?vue&type=script&lang=js"
export * from "./RegistrationFlow.vue?vue&type=script&lang=js"

import "./RegistrationFlow.vue?vue&type=style&index=0&id=3cda229b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3cda229b"]])

export default __exports__